import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M7,8.06798599 C5.04903226,6.16671417 4.80741935,3.07093785 6.05387097,0 C2.62387097,0.54418825 0,3.450289 0,6.95477102 C0,10.8453783 3.23354839,13.9998637 7.22580645,13.9998637 C10.2173968,14.0181669 12.9109097,12.1910851 14,9.4047472 C11.2903226,10.1115145 8.6912903,9.711841 7,8.06798599 Z"
      transform="rotate(11 2.807 17.885)"/>
  </svg>
);
